import React, { useState } from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';

// Local components
import HelpCenterDrawer from './components/HelpCenterDrawer';

export { HelpCenterDrawer };

function CommonHelpCenter({ context, slug, customerSuccesses }) {
  // States
  const [open, setOpen] = useState(false);

  return (
    <>
      <Mui.Button
        variant="outlined"
        color="inherit"
        size="small"
        onClick={() => setOpen(true)}
        startIcon={<Mui.Icon>help_outline</Mui.Icon>}
        style={{ textTransform: 'none', fontWeight: 'bold' }}>
        Ajuda
      </Mui.Button>
      <HelpCenterDrawer
        open={open}
        onClose={() => setOpen(false)}
        context={context}
        slug={slug}
        customerSuccesses={customerSuccesses}
      />
    </>
  );
}

CommonHelpCenter.propTypes = {
  context: PropTypes.oneOf(['sellers', 'institutions']),
  slug: PropTypes.string,
  customerSuccesses: PropTypes.array,
};

export default CommonHelpCenter;
